import { Flame, Volume2, Layers } from "lucide-react";

const SPECS = [
  {
    icon: Flame,
    value: "65%",
    label: "Heat Loss Reduction",
    note: "U-value down to 1.8 W/m²K — Building Regs compliant for retrofit.",
  },
  {
    icon: Volume2,
    value: "80%",
    label: "Noise Reduction",
    note: "Up to 45 dB attenuation across the 100–3,150 Hz traffic spectrum.",
  },
  {
    icon: Layers,
    value: "20mm",
    label: "Ultra-Slim Profile",
    note: "Powder-coated aluminium frame, sight-lines invisible from the street.",
  },
];

const ROWS = [
  { property: "Frame depth", ours: "20 mm aluminium", standard: "45–60 mm uPVC" },
  { property: "Glass weight class", ours: "10.8 mm acoustic laminate", standard: "4 mm float" },
  { property: "Noise reduction (Rw)", ours: "45 dB", standard: "24 dB" },
  { property: "U-value", ours: "1.8 W/m²K", standard: "3.1 W/m²K" },
  { property: "UV block", ours: "99%", standard: "25%" },
  { property: "Listed-building suitable", ours: "Yes", standard: "Rarely" },
];

export const AcousticTechSpecs = () => {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="font-playfair italic text-amber-700/80 tracking-[0.25em] uppercase text-xs mb-4">
            Engineered in Millimetres
          </p>
          <h2 className="font-playfair text-3xl md:text-5xl text-stone-900 font-light leading-tight">
            10.8mm Acoustic Glass, Quantified
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-20">
          {SPECS.map(({ icon: Icon, value, label, note }) => (
            <div key={label} className="text-center px-4">
              <div className="mx-auto h-16 w-16 rounded-full border border-stone-300 flex items-center justify-center mb-6">
                <Icon size={26} strokeWidth={1.25} className="text-stone-800" />
              </div>
              <p className="font-playfair text-5xl text-stone-900 font-light tracking-tight">{value}</p>
              <p className="mt-2 text-xs uppercase tracking-[0.22em] text-stone-500">{label}</p>
              <p className="mt-4 text-sm text-stone-600 leading-relaxed max-w-[26ch] mx-auto">{note}</p>
            </div>
          ))}
        </div>

        <div className="border-t border-stone-200">
          <p className="font-playfair italic text-center text-stone-500 text-sm tracking-wide pt-10 mb-6">
            Our slim aluminium system vs. standard uPVC secondary glazing
          </p>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-stone-200">
                  <th className="text-left font-normal text-xs uppercase tracking-[0.18em] text-stone-500 py-4 pr-4">Specification</th>
                  <th className="text-left font-playfair text-base text-stone-900 py-4 pr-4">Our 10.8mm System</th>
                  <th className="text-left text-xs uppercase tracking-[0.18em] text-stone-400 py-4">Standard Secondary Glazing</th>
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r, i) => (
                  <tr key={r.property} className={i % 2 ? "bg-stone-50/60" : ""}>
                    <td className="py-4 pr-4 text-stone-700">{r.property}</td>
                    <td className="py-4 pr-4 text-stone-900 font-medium">{r.ours}</td>
                    <td className="py-4 text-stone-500">{r.standard}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AcousticTechSpecs;